import React from 'react'
import { Pivot, PivotItem } from '@fluentui/react';
import SiteList from './SiteList';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import { PowerPlatformPanel } from './PowerPlatform/PowerPlatformPanel';

const AdministrationPanel = () => {
    
    const defaultSelectedKey = getPivotItemKeyFromUrl('SharePoint');

    return(
        <div style={{backgroundColor: '#F8F8F8', minHeight:'500px', padding:'0px 20px 20px 20px', minWidth:'850px'}}>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl()}>
                <PivotItem itemKey='SharePoint' headerText='SharePoint' >   
                    <SiteList />
                </PivotItem>
                <PivotItem itemKey='PowerPlatform' headerText='PowerPlatform'>
                    <PowerPlatformPanel parentPivotKey='PowerPlatform'/>
                </PivotItem>
            </Pivot>
        </div>
    );
    
}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

export default AdministrationPanel




// WEBPACK FOOTER //
// ./src/components/Administration/AdministrationPanel.js